import React from 'react';
import styled from 'styled-components';
import Select from '../../dev/Select'

const option = [
    { value: 'Admin', label: 'Admin', clearableValue: false },
    { value: 'Member', label: 'Member', clearableValue: false}
]
const IdentitySelect = ({ id, identity, idenetitySelect }) =>  {
        return (
            <SelectWrap>
                <StyledSelect
                    // name="identity"
                    // value={identity}
                    onChange={e => idenetitySelect(e,id,identity)}
                    placeholder={identity}
                    id='identityType'
                    options={option}
                    isSearchable={false}
                />
            </SelectWrap>
        );
}
export default IdentitySelect;
const SelectWrap = styled.div`
    height: auto;
    margin-bottom: .4rem;
`
const StyledSelect = styled(Select)`
    .select__control {
        min-height: 30px;
        margin: 2px 0;
    }
    .select__value-container {
        padding: 0 8px;
    }
    .select__dropdown-indicator {
        padding: 0;
    }
`


// WEBPACK FOOTER //
// ./src/UserInfo/dev/IdentitySelect.js